
<template>
  <span
    :class="[
      'px-2 py-1 text-xs font-semibold rounded-full',
      statusClasses
    ]"
  >
    {{ formatStatus(status) }}
  </span>
</template>

<script setup lang="ts">
import { TicketStatus } from '@/types/custom-ticket-types';

const props = defineProps<{
  status: TicketStatus | string // Allow string for flexibility if enum parsing fails
}>();

const statusClasses = computed(() => {
  switch (props.status) {
  case TicketStatus.Open:
  case 'OPEN':
    return 'bg-primary/10 text-primary';
  case TicketStatus.InProgress:
  case 'IN_PROGRESS':
    return 'bg-blue-100 text-blue-800';
  case TicketStatus.Resolved:
  case 'RESOLVED':
    return 'bg-purple-100 text-purple-800';
  case TicketStatus.Closed:
  case 'CLOSED':
    return 'bg-gray-100 text-gray-800';
  default:
    return 'bg-gray-100 text-gray-800';
  }
});

const formatStatus = (status: string) => status.replace(/_/g, ' ');
</script>
